import { render, staticRenderFns } from "./TelevisaoIcon.vue?vue&type=template&id=70e12d6b&scoped=true"
import script from "./TelevisaoIcon.vue?vue&type=script&lang=js"
export * from "./TelevisaoIcon.vue?vue&type=script&lang=js"
import style0 from "./TelevisaoIcon.vue?vue&type=style&index=0&id=70e12d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e12d6b",
  null
  
)

export default component.exports